<div
  style="page-break-inside: avoid;"
  class="mt-4"
  *ngIf="incomeFormBusinessData.length > 0"
  [ngClass]="{
    'container': true,
    'return-view-background-print': printActive,
    'return-view-background': !printActive
  }"
>
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF INCOME FROM BUSINESS OR PROFESSION</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}
    </div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>

  <div class="row mt-3 mb-5">
    <div class="col-sm-12">
      <strong>TIN</strong>
      <span class="ml-3" style="white-space: nowrap;">
        <input
          value="{{ tinChar }}"
          *ngFor="let tinChar of ((returnData?.profileData?.tin || '') + '').split('')"
          class="input-default"
          disabled
        />
      </span>
    </div>
  </div>

  <!-- Royalty / Intangibles: render once for all matching business entries -->
  <ng-container *ngIf="getRoyaltyTableRows().length > 0">
    <div class="col-12 mb-3">
      <div class="col-12 mb-3 return-view-section-title">
        Business Income from Royalty, Intangibles etc.
      </div>
      <div class="table-responsive tableBgStyle table-bank-fi" id="dynamicTableRoyalty">
        <table class="table table-bordered income-financial-assets-table">
          <thead>
            <tr class="text-center">
              <th></th>
              <th>Income Type</th>
              <th>Payment Authority</th>
              <th>Date of Payment</th>
              <th>Gross Amount</th>
              <th>Related Expenses</th>
              <th>Net Income</th>
              <th>TDS</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of getRoyaltyTableRows(); let rowIdx = index">
              <td class="text-center">{{ rowIdx + 1 }}</td>
              <td>{{ getValue(row, 'businessTypeName') || getValue(row, 'businessType') }}</td>
              <td>{{ getValue(row, 'businessName') || getValue(row, 'businessNm') }}</td>
              <td>{{ getValue(row, 'paymentDate') }}</td>
              <td class="text-right pr-3">{{ getValue(row, 'grossProfit') | currencySeparatorBD }}</td>
              <td class="text-right pr-3">{{ getValue(row, 'otherExpenseAmount') | currencySeparatorBD }}</td>
              <td class="text-right pr-3">{{ getRoyaltyRowNetIncomeValue(row) | currencySeparatorBD }}</td>
              <td class="text-right pr-3">{{ getRoyaltyRowTdsValue(row) | currencySeparatorBD }}</td>
            </tr>
            <tr class="font-weight-bold">
              <td class="text-center" colspan="4">Total</td>
              <td class="text-right pr-3">{{ getRoyaltyTableTotalGrossProfit() | currencySeparatorBD }}</td>
              <td class="text-right pr-3">{{ getRoyaltyTableTotalOtherExpenseAmount() | currencySeparatorBD }}</td>
              <td class="text-right pr-3">{{ getRoyaltyTableNetIncome() | currencySeparatorBD }}</td>
              <td class="text-right pr-3">{{ getRoyaltyTableTotalTds() | currencySeparatorBD }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>

  <div *ngFor="let item of incomeFormBusinessData; let idx = index" style="page-break-inside: avoid;" class="row mb-5">
    <!-- Royalty/Intangibles UI: per requirement, no separate text fields; show only the table. -->
    <div class="col-12 mb-4 return-view-section-title" *ngIf="!isRoyaltyIntangiblesCategory(item)">
      {{ getBusinessCategoryTitle(getValue(item, businessCategoryKey)) }}
    </div>
    <ng-container *ngIf="!isRoyaltyIntangiblesCategory(item)">
      <div class="col-12 mb-3">
        <div class="return-view-text-fields">
          <ng-container *ngFor="let field of getTextParticulars(item)">
            <div class="return-view-text-field" *ngIf="shouldShowTextField(field)">
              <span class="return-view-text-label">{{ field.title }}:</span>
              <span class="return-view-text-value">{{ getTextFieldDisplayValue(item, field) }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <div class="col-12" *ngIf="!isRoyaltyIntangiblesCategory(item) && !isFailureOfDeduction(item) && !isAdjustment46(item) && getAmountParticulars(item).length > 0">
      <table class="table table-bordered income-business-table">
        <thead>
          <tr class="text-center">
            <th style="width: 70%">Particulars</th>
            <th style="width: 30%">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let particular of getAmountParticulars(item)">
            <td>{{ getAmountParticularTitle(particular, item) }}</td>
            <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12 mt-4" *ngIf="!isRoyaltyIntangiblesCategory(item) && getExpenseParticulars(item) as expenseRows">
      <ng-container *ngIf="expenseRows.length > 0">
        <div class="text-center mb-2"><strong>Total general, administrative, selling & other expenses (Breakdown)</strong></div>
        <table class="table table-bordered income-business-table">
          <thead>
            <tr class="text-center">
              <th style="width: 70%">Particulars</th>
              <th style="width: 30%">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let particular of expenseRows">
              <td>{{ particular.title }}</td>
              <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>

    <div class="col-12 mt-4" *ngIf="!isRoyaltyIntangiblesCategory(item) && getBalanceSheetParticulars(item) as balanceRows">
      <ng-container *ngIf="balanceRows.length > 0">
        <div class="text-center mb-2"> <strong>Balance Sheet Summary</strong></div>
        <table class="table table-bordered income-business-table">
          <thead>
            <tr class="text-center">
              <th style="width: 70%">Particulars</th>
              <th style="width: 30%">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let particular of balanceRows">
              <td>{{ particular.title }}</td>
              <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>

    <div class="col-12" *ngIf="isAdjustment46(item) && getAdjustment46List(item).length > 0">
      <!-- <div class="mb-2">
        <strong>Other Income/Adjustment U/S 46</strong>
      </div> -->
      <table class="table table-bordered income-business-table">
        <thead>
          <tr class="text-center">
            <th style="width: 5%">SL</th>
            <th style="width: 65%">Particulars</th>
            <th style="width: 30%">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of getAdjustment46List(item); let rowIdx = index">
            <td class="text-center">{{ rowIdx + 1 }}</td>
            <td>{{ getAdjustmentParticularTitle(getAdjustment46RowValue(row, 'particulars')) }}</td>
            <td class="text-right pr-3">{{ getAdjustment46RowValue(row, 'amount') | currencySeparatorBD }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="font-weight-bold">
            <td></td>
            <td>Special Business Income</td>
            <td class="text-right pr-3">{{ getSpecialBusinessIncome(item) | currencySeparatorBD }}</td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="col-12" *ngIf="isFailureOfDeduction(item) && getFailureOfDeductionList(item).length > 0">
      <!-- <div class="mb-2">
        <strong>Failure of deduction, collection or payment of source Tax U/S 56</strong>
      </div> -->
      <table class="table table-bordered income-business-table">
        <thead>
          <tr class="text-center">
            <th style="width: 5%">SL</th>
            <th *ngFor="let column of failureOfDeductionColumns" [style.width.%]="column.isAmount ? 19 : 24">
              {{ column.title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of getFailureOfDeductionList(item); let rowIdx = index">
            <td class="text-center">{{ rowIdx + 1 }}</td>
            <td *ngFor="let column of failureOfDeductionColumns" [class.text-right]="column.isAmount" [class.pr-3]="column.isAmount">
              <ng-container *ngIf="column.isAmount; else textValue">
                {{ getFailureOfDeductionRowValue(row, column.key) | currencySeparatorBD }}
              </ng-container>
              <ng-template #textValue>{{ getFailureOfDeductionRowValue(row, column.key) }}</ng-template>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="font-weight-bold">
            <td colspan="2">Total</td>
            <td class="text-right pr-3">{{ getFailureOfDeductionTotal(item, 'amount') | currencySeparatorBD }}</td>
            <td class="text-right pr-3">{{ getFailureOfDeductionTotal(item, 'tdsAmount') | currencySeparatorBD }}</td>
            <td class="text-right pr-3">{{ getFailureOfDeductionTotal(item, 'tds50Parent') | currencySeparatorBD }}</td>
            <td class="text-right pr-3">{{ getFailureOfDeductionTotal(item, 'totalPayable') | currencySeparatorBD }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
